import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, ButtonGroup, ButtonProps, Divider, useDisclosure } from '@chakra-ui/react';
import IconFileCopy from 'assets/icons/icon-file-copy.svg?react';
import React from 'react';

type ButtonDuplicateContentProps = Partial<ButtonProps>;

export default function ButtonDuplicateContent({ onClick, ...props }: ButtonDuplicateContentProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef()

  return (
    <>
      <Button
        size="sm"
        rightIcon={<IconFileCopy />}
        {...props}
        onClick={(e) => {
          if (onClick) {
            onOpen();
          }
        }}
      >
        Usar como modelo
      </Button>
      
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Confirmação
            </AlertDialogHeader>

            <AlertDialogBody mt="10px">
              Essa ação irá duplicar esse Disparo de Report.<br />
              Você tem certeza disso? Você não pode desfazer essa ação
            </AlertDialogBody>

            <Divider />

            <AlertDialogFooter>
              <ButtonGroup>
                <Button ref={cancelRef} onClick={onClose}>
                  Cancelar
                </Button>
                <Button 
                  variant="primary" 
                  size="sm" 
                  onClick={(e) => {
                    onClose();
                    if (onClick)
                      onClick(e);
                  }}>  
                  Confirmar
                </Button>
              </ButtonGroup>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
